import { t } from '@lingui/macro';
import { AlarmsAcknowledgeType, DataOptionsType, IntervalOptionsType } from '@shared/models';

// - - - DASHBOARD - - -

export const IntervalOptionsFn = (): Record<IntervalOptionsType, string> => ({
  [IntervalOptionsType.Auto]: t`Auto`,
  [IntervalOptionsType.Logger]: t`Logger`,
  [IntervalOptionsType.Min1]: `1 ${t`Minute`}`,
  [IntervalOptionsType.Min5]: `5 ${t`Minutes`}`,
  [IntervalOptionsType.Min10]: `10 ${t`Minutes`}`,
  [IntervalOptionsType.Min15]: `15 ${t`Minutes`}`,
  [IntervalOptionsType.Min30]: `30 ${t`Minutes`}`,
  [IntervalOptionsType.Hour1]: `1 ${t`Hour`}`,
  [IntervalOptionsType.Hour6]: `6 ${t`Hours`}`,
  [IntervalOptionsType.Hour12]: `12 ${t`Hours`}`,
  [IntervalOptionsType.Day1]: `1 ${t`Day`}`,
});

export const DataOptionsFn = (): Record<DataOptionsType, string> => ({
  [DataOptionsType.Primary]: t`Primary`,
  [DataOptionsType.Secondary]: t`Secondary`,
  [DataOptionsType.All]: t`All`,
});

// - - - ALARMS - - -

export const AlarmsAcknowledgeOptionsFn = () => ({
  [AlarmsAcknowledgeType.All]: t`All`,
  [AlarmsAcknowledgeType.Acknowledged]: t`Acknowledged`,
  [AlarmsAcknowledgeType.New]: t`New Alarms`,
});
